import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { SetupSearch } from 'areas/shared/pages/setup';
import { DateRangePicker, SearchBox } from 'fw/forms';
import * as API from 'modules/app/API';
import { TrueFalseFilter, PaypalInvoiceStatusCombo } from 'areas/shared/controls';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

class Search extends SetupSearch {

	initialForm() {
		
		var params = queryString.parse(this.props.location.search);

		var initialStatusFilter = null;

		// If Status param came from Dashboard filter by it
		if (params.status != null){
			initialStatusFilter = params.status;
		}

        return {
            keyword: "",
            status: initialStatusFilter,
        };
	}

	ready = () => {
		this.focusControl && this.focusControl.focus();
	}

	searchLoader = () => {
		return {
			url: API.Search.url('/suggest'),
			params: { type: 'paypalInvoices' }
		}
	}

	renderForm() {
		return (
			<React.Fragment>
				<Row>
					<Col md={7}>
						<Row>
							<Col md={8}>
								<SearchBox
									name="keyword"
									placeholder="Search by keyword..."
									loader={this.searchLoader}
									ref={(c) => { this.focusControl = c }} />
							</Col>
							<Col md={4}>
								<SearchBox 
									name="invoiceNumber" 
									placeholder="Invoice #" 
									loader={this.searchLoader}
									clearable/>
							</Col>
						</Row>
						<Row style={{marginTop:'5px'}}>
							<Col md={8}>
								<PaypalInvoiceStatusCombo
									name="status"
									onChange={this.search} 
									clearable />
							</Col>
							<Col md={4}>
								<TrueFalseFilter name="imported" 
									onChange={this.search} 
									trueLabel="Imported"
									falseLabel="Not Imported"
									placeholder="Imported Status" />
							</Col>
						</Row>
					</Col>
					<Col md={3}>
							<DateRangePicker 
								name="dateRange" 
								placeholder="Date" 
								futureOptions={false}/>
					</Col>
				</Row>
				
			</React.Fragment>
		)
	}
}

export default withRouter(Search);


// WEBPACK FOOTER //
// ./src/areas/admin/paypalInvoiceSetup/Search.js